import {
  IReferral,
  IReferralNote,
  ReferralCollection,
} from '@principle-theorem/principle-core/interfaces';
import {
  AtLeast,
  CollectionReference,
  Firestore,
  IReffable,
  WithRef,
  multiUndeleted,
  subCollection,
} from '@principle-theorem/shared';
import { Observable } from 'rxjs';

export class ReferralNote {
  static init(
    overrides: AtLeast<IReferralNote, 'content' | 'actor'>
  ): IReferralNote {
    return {
      deleted: false,
      ...overrides,
    };
  }

  static col(
    referral: IReffable<IReferral>
  ): CollectionReference<IReferralNote> {
    return subCollection<IReferralNote>(referral.ref, ReferralCollection.Notes);
  }

  static all$(
    referral: IReffable<IReferral>
  ): Observable<WithRef<IReferralNote>[]> {
    return Firestore.query$(ReferralNote.col(referral)).pipe(multiUndeleted());
  }
}
